import React from 'react';
import { useTranslation } from 'react-i18next';

/** Pastille « BÊTA » d'une partie encore en test (menu coach, titre de page). */
const BetaBadge = ({ className = '' }) => {
  const { t } = useTranslation('common');
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full bg-[rgba(212,132,90,0.15)] px-[7px] py-[4px] text-[10px] font-medium uppercase leading-none tracking-[0.06em] text-kaiylo-accent ${className}`}
      data-testid="beta-badge"
    >
      {t('nav.beta')}
    </span>
  );
};

export default BetaBadge;
